import {
  type PagingMetadataV2,
  type Service,
} from '@wix/ambassador-bookings-services-v2-service/types';
import { AsyncComponentData, AsyncComponentDataStatus } from '../../types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { manageWarmupData } from '@wix/bookings-catalog-calendar-viewer-utils';
import { getServices } from '../adapters/getServices';
import settingsParams from '../../settingsParams';

export type State = {
  services: AsyncComponentData<{
    services: Service[];
    pagingMetadata: PagingMetadataV2;
  }>;
};

export const getInitialState = async ({
  flowAPI,
}: {
  flowAPI: ControllerFlowAPI;
}): Promise<State> => {
  try {
    const selectedServices = flowAPI.settings.get(
      settingsParams.selectedServices,
    );
    const servicesResponse = await manageWarmupData(
      () => getServices(flowAPI.httpClient, { selectedServices }),
      `services-${JSON.stringify(selectedServices)}`,
      flowAPI,
    );
    return {
      services: {
        status: AsyncComponentDataStatus.IDLE,
        data: {
          services: servicesResponse.services!,
          pagingMetadata: servicesResponse.pagingMetadata!,
        },
      },
    };
  } catch (error) {
    return {
      services: { status: AsyncComponentDataStatus.ERROR, data: error },
    };
  }
};
